import { FC } from 'react';
import { useGetFcos } from '../../../api/fcos';
import { FeatureServiceFCOFields, WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { Empty, Loading } from '@lithos';
import { useUserSettings } from '../../context/UserSettingsContext';
import { TransformServerGroup } from '../../../types/tecton_proto/servergroupservice/server_group_service';
import FeatureServicesList from '../../featureServices/Redesign/FeatureServicesList';

const TransformServerGroupFeatureServicesTableView: FC<{ serverGroup: TransformServerGroup }> = ({ serverGroup }) => {
  const { workspace } = useUserSettings();

  const { data, isLoading, isError } = useGetFcos(workspace ?? '', {
    select: (data: WorkspaceFCOContainer) => {
      return {
        featureServices: data?.featureServices.filter((featureService) => {
          return featureService[FeatureServiceFCOFields.TRANSFORM_SERVER_GROUP_NAME] === serverGroup.name;
        }),
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <Empty
        placement="full-page"
        actions={[]}
        useCase="errorUnknown"
        title="Unknown Error"
        description="Error loading feature views"
      />
    );
  }

  return (
    <FeatureServicesList
      items={data?.featureServices ?? []}
      idToFcoMap={data?.idToFcoMap ?? {}}
      workspace={workspace ?? ''}
    />
  );
};

export default TransformServerGroupFeatureServicesTableView;
